<div>
    <div *ngIf="!isDialog" name="queryBuilder" name="queryBuilder" class="query-builder">
        <div class="query-sample-output media alert alert-info">
            <p class="info-head media-left media-middle">{{locale.LABEL_CRITERIA_PREVIEW}}</p>
            <p class="info-msg media-body media-middle" [innerHtml]="filterCriteriaService.data.queryPreview"></p>
        </div>
        <wms-criteria-group depth="0" [filterFields]="filterFields" [liveWidgetSettingsService]="liveWidgetSettingsService" [rules]="filterExpressions" isDefaultGroup="true"></wms-criteria-group>
    </div>
  <div *ngIf="isDialog" class="form-group app-composite-widget clearfix query-form-group">
    <label class="col-md-3 control-label app-label">{{locale.LABEL_FILTER_CRITERIA}}</label>
    <div class="col-md-9 media">
      <textarea disabled class="form-control app-textarea expression-box media-body" [(ngModel)]="sanitisedQuery"></textarea>
      <button type="button" title="{{locale.LABEL_EDIT_CRITERIA}}" class="media-right wm-icon wms wms-edit edit" (click)="openFilterCriteriaDialog('WmsCriteriaBuilderDialog')"></button>
    </div>
  </div>
</div>
